<h2>Frequently Asked Questions</h2>
<mat-accordion [multi]="true">
    <mat-expansion-panel *ngFor="let faq of faqs">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ faq.question }}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{ faq.answer }}</p>
    </mat-expansion-panel>
</mat-accordion>
